import liveFn from '@/views/NewLive/liveFn';
import { getUserTagConfig } from '@/views/NewLive/studio/components/config';
import { ShowUserInfo, UserTagEnum } from '@/views/NewLive/typings';

export function getCustomInfo(showUser?: ShowUserInfo) {
  if (liveFn.getShowLivePlatform() === '96show' && showUser) {
    return {
      uid: Number(showUser?.id || 0),
      nickname: showUser?.nick_name ?? '',
      head_img: showUser?.head_img ?? '',
      showUserId: showUser?.show_user_id ?? ''
    };
  }
  return {};
}

export function hasCurrentUser(boxUserId?: number, infoUid?: number, showUser?: ShowUserInfo) {
  const intBoxUserId = Number(boxUserId ?? 1);
  const intiInfoUid = Number(infoUid ?? 0);
  const showUserId = Number(getCustomInfo(showUser)?.uid ?? -1);
  const userIds = [intBoxUserId, showUserId];
  if (userIds.includes(intiInfoUid)) {
    return true;
  }
  return false;
}

/** 主播是否可对目标用户展示管理类操作（标签/禁言/踢人等） */
export function canAnchorManageUser(
  boxUserId?: number,
  targetUid?: number,
  anchorUid?: number,
  showUser?: ShowUserInfo
): boolean {
  return hasCurrentUser(boxUserId, anchorUid, showUser) && Number(targetUid) !== Number(anchorUid);
}

/** 主播是否可对目标用户展示用户标签（权限 + 有效标签数据） */
export function canShowUserTag(
  boxUserId?: number,
  targetUid?: number,
  anchorUid?: number,
  showUser?: ShowUserInfo,
  userTagType?: UserTagEnum
): boolean {
  return canAnchorManageUser(boxUserId, targetUid, anchorUid, showUser) && !!getUserTagConfig(userTagType);
}

export function transformValuesToString(obj: any) {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (value === null || value === undefined) {
        return [key, ''];
      }
      if (typeof value === 'number') {
        return [key, String(value)];
      }
      return [key, value];
    })
  );
}
